import React from "react";
import "./index.css";

const Container = ({ children, className = "" }) => {
  return (
    <div className={`containerWidth ${className}`}>
      {children}
    </div>
  );
};

export default Container;
